import router from "@/router";
import axios from "axios";
import { storeSlug } from "@/global/storeAddress";

const apiBaseURL = `${process.env.VUE_APP_API_BASE_URL}`;

const axiosClient = axios.create({
  baseURL: apiBaseURL,
  // Store opened through the platform address (bardyapp.com.br/<slug>): tells the API which store it is.
  headers: storeSlug ? { 'X-Store-Slug': storeSlug } : {},
});

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 - Token inválido ou expirado
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('customer');
      router.push({ name: 'login' });
    }

    // Unknown store (no domain/slug mapped): show the "store not found" page instead of loading forever.
    const uniqueCode = error.response?.data?.errors?.[0]?.uniqueCode
    if (uniqueCode === 'DOMAIN_NOT_FOUND' || uniqueCode === 'ORIGIN_NOT_IDENTIFIED') {
      router.replace({ name: 'nonexistent-domain' });
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
